import { CategoryId } from '$/epg/categories'
import { PARAM, RESERVED_NAME } from '@/constants/path'

export function getCategoryIdFromQuery(
  query?: URLSearchParams | undefined
): number | CategoryId | undefined {
  const id = query?.get(PARAM.CATEGORY)
  if (id == null) return undefined

  // Handle reserved values
  if (id === RESERVED_NAME.ALL) {
    return CategoryId.All
  }
  if (id === RESERVED_NAME.MY_LIST) {
    return CategoryId.Favorite
  }

  // Handle numeric values
  const idn = Number(id)
  if (isNaN(idn)) return undefined
  return idn
}
